/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionTypeEnum } from './QuestionTypeEnum';
import { QuestionTypeEnumFromJSON, QuestionTypeEnumFromJSONTyped, QuestionTypeEnumToJSON } from './QuestionTypeEnum';

/**
 *
 * @export
 * @interface CustomQuestionnaireQuestionForAnswer
 */
export interface CustomQuestionnaireQuestionForAnswer {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  description?: string | null;
  /**
   *
   * @type {QuestionTypeEnum}
   * @memberof CustomQuestionnaireQuestionForAnswer
   */
  questionType: QuestionTypeEnum;
}

/**
 * Check if a given object implements the CustomQuestionnaireQuestionForAnswer interface.
 */
export function instanceOfCustomQuestionnaireQuestionForAnswer(
  value: object,
): value is CustomQuestionnaireQuestionForAnswer {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('text' in value) || value['text'] === undefined) return false;
  if (!('questionType' in value) || value['questionType'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireQuestionForAnswerFromJSON(json: any): CustomQuestionnaireQuestionForAnswer {
  return CustomQuestionnaireQuestionForAnswerFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionForAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionForAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    order: json['order'] == null ? undefined : json['order'],
    name: json['name'],
    text: json['text'],
    description: json['description'] == null ? undefined : json['description'],
    questionType: QuestionTypeEnumFromJSON(json['question_type']),
  };
}

export function CustomQuestionnaireQuestionForAnswerToJSON(
  value?: Omit<CustomQuestionnaireQuestionForAnswer, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    order: value['order'],
    name: value['name'],
    text: value['text'],
    description: value['description'],
    question_type: QuestionTypeEnumToJSON(value['questionType']),
  };
}
